import script from "./TopThree.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopThree.vue?vue&type=script&setup=true&lang=ts"

import "./TopThree.vue?vue&type=style&index=0&id=1c5aa0be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c5aa0be"]])

export default __exports__